import { Hover } from "react-powerplug";
import { Popover } from "lib/miolo";
import { useId, useState } from "react";
import { CircleHelpIcon, HelpCircleIcon } from "lucide-react";

export default function CalendarNotes() {
  const helpPopoverId = useId();
  const [isHelpOpen, setIsHelpOpen] = useState(false);

  return (
    <>
      <div className="hidden md:flex">
        <Hover key={helpPopoverId}>
          {({ bind, hovered }) => (
            <Popover
              className="flex rounded-xl border border-gray-200 p-2 font-aeonik text-xs normal-case text-gray-500 shadow-md"
              trapFocus={true}
              id={helpPopoverId}
              isOpen={hovered}
              placement="top"
              showArrow={false}
              renderWithPortal={false}
              backgroundColor="#FFFFFF"
              containerStyle={{
                zIndex: 9999,
                borderRadius: 12,
              }}
              render={() => (
                <span>
                  Você pode filtrar eventos no calendário dentro do prazo de 1 ano, sendo até 6 meses no passado e até 6
                  meses no futuro em relação a data de hoje.
                </span>
              )}
            >
              {({ accessibility, ref }) => (
                <span
                  {...accessibility}
                  {...bind}
                  ref={ref}
                  className="grid grid-flow-col gap-1 text-justify font-aeonik text-xs text-gray-600 hover:cursor-pointer"
                >
                  <HelpCircleIcon className="size-3.5" />
                  Limites de Datas no Calendário
                </span>
              )}
            </Popover>
          )}
        </Hover>
      </div>

      <div className="flex md:hidden">
        <Popover
          className="mx-2 flex rounded-xl border border-gray-200 p-2 font-aeonik text-xs normal-case text-gray-500 shadow-md"
          trapFocus={true}
          placement="top"
          id={helpPopoverId}
          isOpen={isHelpOpen}
          onClose={() => setIsHelpOpen(false)}
          showArrow={false}
          renderWithPortal={false}
          backgroundColor="#FFFFFF"
          containerStyle={{
            zIndex: 9999,
            borderRadius: 12,
          }}
          render={() => (
            <span>
              Você pode filtrar eventos no calendário dentro do prazo de 1 ano, sendo até 6 meses no passado e até 6
              meses no futuro em relação a data de hoje.
            </span>
          )}
        >
          {({ accessibility, ref }) => (
            <button
              {...accessibility}
              ref={ref}
              className="m-0 flex"
              onClick={() => {
                setIsHelpOpen((previous) => !previous);
              }}
              type="button"
            >
              <span
                {...accessibility}
                ref={ref}
                className="grid grid-flow-col gap-1 text-justify font-aeonik text-xs text-gray-600 hover:cursor-pointer"
              >
                <CircleHelpIcon className="size-3.5" />
                Limites de Datas no Calendário
              </span>
            </button>
          )}
        </Popover>
      </div>
    </>
  );
}
